/** "Where people reach it" in About this agent and the guided builder (ADR-0099). */
export default {
  en: {
    // G-camp-gov-01 (ADR-0109): what the agent may send people.
    maySend: {
      title: "What it may send people",
      help: "Messages by e-mail, chat apps or SMS. A service message to the person's own address about their own request needs nothing more; anything else needs the person's consent, which the agent can record when they give it in the conversation (they can withdraw it any time).",
      notifications: "Notifications",
    },
    title: "Where people reach it",
    help: "Turn on each place this agent answers. A message from a place that is off is refused with a short, polite reply.",
    channel: {
      web: "Assistant in this console",
      api: "Other programs (API key)",
      widget: "Website chat",
      email: "E-mail mailbox",
      chat: "Chat apps (Teams, Slack, WhatsApp…)",
      voice: "Voice calls",
      mcp: "Other AI tools (MCP)",
    },
    state: {
      ready: "Ready",
      notSetUp: "On here, but not set up in your organisation yet: nobody can reach it there.",
      refused: "Set up in your organisation for this agent, but off here: people there are refused.",
      unknown: "Can't check the set-up (no access).",
      offOk: "Off",
    },
    shows: {
      native: "Buttons, cards and forms show as they are.",
      text: "Buttons become numbered choices and links are written out.",
      voice: "Choices are read aloud (“say one for …”).",
    },
    setUp: "Set it up",
    turnOn: "Turn it on",
    mailboxUse: "Answer the e-mail mailbox with this agent",
    mailboxOther: "The mailbox goes to {{agent}} now.",
    mailboxDone: "The e-mail mailbox now goes to this agent.",
    mailboxNone: "No mailbox is connected yet.",
    failed: "That didn't work: {{message}}",
  },
  ar: {
    maySend: {
      title: "ما يمكنه إرساله للناس",
      help: "رسائل بالبريد أو تطبيقات المحادثة أو الرسائل النصية. رسالة الخدمة المرسلة إلى عنوان الشخص نفسه بشأن طلبه لا تحتاج إلى شيء آخر؛ وأي رسالة أخرى تحتاج إلى موافقة الشخص، ويمكن للوكيل تسجيلها حين يقدّمها في المحادثة (ويمكنه سحبها في أي وقت).",
      notifications: "الإشعارات",
    },
    title: "أين يصل إليه الناس",
    help: "فعّل كل مكان يجيب فيه هذا الوكيل. تُرفض الرسالة الواردة من مكان غير مفعّل برد قصير ومهذب.",
    channel: {
      web: "المساعد في هذه الواجهة",
      api: "برامج أخرى (مفتاح API)",
      widget: "محادثة الموقع",
      email: "صندوق البريد الإلكتروني",
      chat: "تطبيقات المحادثة (Teams وSlack وWhatsApp…)",
      voice: "المكالمات الصوتية",
      mcp: "أدوات ذكاء اصطناعي أخرى (MCP)",
    },
    state: {
      ready: "جاهز",
      notSetUp: "مفعّل هنا لكنه غير مُعدّ في مؤسستك بعد: لا يستطيع أحد الوصول إليه هناك.",
      refused: "مُعدّ في مؤسستك لهذا الوكيل لكنه غير مفعّل هنا: يُرفض الناس هناك.",
      unknown: "تعذّر التحقق من الإعداد (لا صلاحية).",
      offOk: "غير مفعّل",
    },
    shows: {
      native: "تظهر الأزرار والبطاقات والنماذج كما هي.",
      text: "تصبح الأزرار خيارات مرقّمة وتُكتب الروابط.",
      voice: "تُقرأ الخيارات بصوت عالٍ («قل واحد لـ …»).",
    },
    setUp: "إعداده",
    turnOn: "تفعيله",
    mailboxUse: "اجعل هذا الوكيل يجيب صندوق البريد",
    mailboxOther: "يذهب الصندوق الآن إلى {{agent}}.",
    mailboxDone: "صار صندوق البريد يذهب إلى هذا الوكيل.",
    mailboxNone: "لم يُربط صندوق بريد بعد.",
    failed: "لم ينجح ذلك: {{message}}",
  },
};
